import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { tankCardDataType } from '../../models/atg-dashboard';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [TranslocoDirective],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss'
})
export class Tooltip {
  public tooltipType!:'tank-card';
  public tooltipData!:tankCardDataType;
}
